import { notification } from 'antd';

const openNotification = (type, message, description) => {
  notification[type]({
    duration: 2,
    message: message,
    description: description,
  });
};

class Notification {
  static error = description => {
    openNotification('error', 'Error', description);
  };
  static success = description => {
    openNotification('success', 'Success', description);
  };
  static warning = description => {
    openNotification('warning', 'Warning', description);
  };
  static info = description => {
    openNotification('info', 'Info', description);
  };
}

export default Notification;
